export const PROMO_CODE_STORAGE_KEY = 'ticket-zone-promo-code';
